module.exports = __webpack_public_path__ + "img/ic_logo_bwin_small.7d2ea22e.svg";